import angular from 'angular';
import URLS from 'Helpers/urls';
import UTILS from 'Helpers/util';

(function () {
    'use strict';

    angular.module('app').component('record', {
        template: require('./record.html'),
        controller: Ctrl,
        controllerAs: 'vm'
    });

    Ctrl.$inject = [
        '$scope',
        '$state',
        '$rootScope',
        '$stateParams',
        'ModalService',
        'QueryService',
        'SessionService',
        'UploadService',
        'logger'
    ];

    function Ctrl(
        $scope,
        $state,
        $rootScope,
        $stateParams,
        ModalService,
        QueryService,
        SessionService,
        UploadService,
        logger
    ) {

        var vm = this;
        vm.devices = [];
        vm.selected_device = 0;
        vm.mode = 'stopped';
        vm.record_button_clicked = record_button_clicked;
        vm.start_record = start_record;
        vm.stop_record = stop_record;
        vm.chunks = [];

        navigator.mediaDevices.enumerateDevices()
            .then(function(devices) {
                const d = devices.filter(s => s.kind == 'audioinput');
                console.log(d);

                d.forEach(_d => vm.devices.push(_d));
                vm.selected_device = '0';
                $scope.$apply();
            });
        
        function start_record(){

            const deviceId = vm.devices[vm.selected_device].deviceId;

            window.AudioContext = window.AudioContext || window.webkitAudioContext;

            vm.context = new AudioContext();

            navigator.mediaDevices.getUserMedia({ 
                audio: { deviceId }
            }).then((stream) => {
                
                vm.recorder = new MediaRecorder(stream);
                vm.recorder.start();


                vm.recorder.ondataavailable = function(e) {
                    vm.chunks.push(e.data);
                }
                
                vm.recorder.onstop = () => {

                    var audio = document.getElementById('audioplayer');
                    audio.setAttribute('controls', '');
                    audio.controls = true;
                    var blob = new Blob(vm.chunks, { 'type' : 'audio/ogg; codecs=opus' });
                    vm.chunks = [];

                    var audioURL = URL.createObjectURL(blob);
                    audio.src = audioURL;
                    audio.play();
                    setTimeout(()=>{
                        audio.pause();
                    }, 200);

                    const file = blobToFile(blob,'test.ogg');

                    UploadService.upload(
                        file,
                        'audio/ogg; codecs=opus',
                        { path: 'chats', type: file.type },
                        location => {
                            console.log(location);
                        }
                    )

                    console.log("recorder stopped", audioURL);
                }
                
            });

            vm.recording_start = new Date();
            set_timer();

        }
        
        function set_timer(){
            const seconds = parseInt((new Date() - vm.recording_start)/1000);
           
            vm.duration = (parseInt(seconds/60)+'').padStart(2, '0') + ':' + (seconds % 60 + '').padStart(2, '0');
           
           
            try{
                $scope.$apply();
            }catch(e){}


            setTimeout(()=>{
                if(vm.mode === 'recording'){
                    set_timer();
                }
            }, 1000);

        }

        function stop_record(){
            vm.recorder.stop();
            vm.mode = 'stopped';
            vm.recorded = 1;
        }
        function record_button_clicked(){

            if(vm.mode === 'stopped'){
                vm.mode = 'recording';
                start_record();
            } else

            if(vm.mode === 'recording'){
                vm.mode = 'stopped';
                stop_record();
            } 

        }

        function blobToFile(theBlob, fileName){
            return new File([theBlob], fileName, {lastModified: new Date(), type: theBlob.type})
        }

    }
})();



// WEBPACK FOOTER //
// ./src/app/components/record/record.component.js